import { api, ApiTags } from '../../api';
import { StateSchema } from '../../StoreProvider';

import { transformPromptsDtoToCards } from './mapper';
import { SearchRequest, SearchResponse, SearchResponseDto } from './types';

export const searchApi = api.injectEndpoints({
    endpoints: build => ({
        /** Поиск */
        search: build.query<SearchResponse, SearchRequest>({
            queryFn: async (arg, { getState }, _, baseQuery) => {
                const { query, size } = arg;
                const state = getState() as StateSchema;
                const exclude = state.search.exclude;

                const result = await baseQuery({
                    url: '/search',
                    method: 'POST',
                    body: { query, size, exclude },
                });

                if (result.error) {
                    return { error: result.error };
                }

                const data = transformPromptsDtoToCards(result.data as SearchResponseDto);

                return { data };
            },
            // Кэшируем только по query - изменение size, exclude не должно сбрасывать кэш
            serializeQueryArgs: ({ queryArgs }) => {
                return queryArgs.query;
            },
            merge: (currentCache, newItems) => {
                currentCache.push(...newItems);
            },
            // Cбрасываем кеш через 3 минут после размонтирования
            keepUnusedDataFor: 180,
            providesTags: [ApiTags.Search],
        }),
    }),
});

export const { useSearchQuery } = searchApi;
